<template>
	<div class="table-page-container">
		<div class="page-header">
			<span class="title" v-if="title">{{ title }}</span>
			<div class="headerContent">
				<slot name="header"> </slot>
			</div>
		</div>
		<div class="page-header-bottom" v-if="$slots['header-bottom']">
			<slot name="header-bottom"></slot>
		</div>
		<div class="page-body-table">
			<div class="table-container">
				<slot name="table"></slot>
			</div>
		</div>
		<div class="page-footer">
			<slot name="footer"></slot>
		</div>
	</div>
</template>
<script>
export default {
  props: ['title']
}
</script>
<style lang="scss" scoped>
.table-page-container {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	.page-header {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		padding-bottom: 10px;
		overflow-x: auto;
		overflow-y: hidden;
		position: sticky;
		top: 0;
		z-index: 100;
		background-color: #fff;
		.title {
			padding-left: 5px;
			border-left: 2px solid #108ee9;
			font-size: 20px;
			font-weight: 700;
			padding-left: 10px;
			min-width: 110px;
			line-height: 32px;
			margin-bottom: 10px;
		}
	}
	.headerContent {
		flex: 1;
		min-width: 300px;
	}
	.page-header-bottom {
		padding-bottom: 10px;
		background-color: #fff;
	}
	.page-body-table {
		flex: 1;
		position: relative;
		overflow: auto;
		.table-container {
			position: absolute;
			width: 100%;
			height: 100%;
		}
	}
	.page-footer {
		z-index: 2;
	}
}
</style>